module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-item-container"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.isSelected,
      "checked": _vm.isSelected
    },
    on: {
      "change": _vm.onSelectTask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "task-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "task-item-text",
      "disabled": !_vm.isSelected,
      "aria-label": "Texto"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onTextChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "delete-item"
  }, [_c('v-icon', {
    staticClass: "delete-icon",
    on: {
      "click": _vm.onCloseTask
    }
  }, [_vm._v("close")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5940f673","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TaskItem.vue
// module id = 1180
// module chunks = 9 10 34